import ReactRenderer from "modules/_react-renderer";

import Counter from "./js/Counter";

ReactRenderer.registerComponent('Test.Counter', Counter);